module.exports = __webpack_public_path__ + "static/media/phoneIcon.0d3281e5.svg";